module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }